<template>
  <div class="radio-list-item-parts" :class="`radio-list-item-parts--${screenOrientationType}`">
    <radio-list-play-button-parts
      :screenOrientationType="screenOrientationType"
      :radioData="playerRadioData"
      @playRadio="playSelectPlayerRadio(false)"
    />

    <button class="radio-list-item-parts__video-scene-select" @click="playSelectPlayerRadio(true)">
      <span class="radio-list-item-parts__video-scene-select__information">
        <span class="radio-list-item-parts__video-scene-select__lap-data"
          >Lap {{ lap }}・{{ sector }}</span
        >
      </span>
      <svg
        class="radio-list-item-parts__video-scene-select__icon"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2 2.25C0.895431 2.25 0 3.14543 0 4.25V13.75C0 14.8546 0.89543 15.75 2 15.75H16C17.1046 15.75 18 14.8546 18 13.75V4.25C18 3.14543 17.1046 2.25 16 2.25H2ZM12.75 9L6.75 5.25V12.75L12.75 9ZM1.50002 3.75014H3.00002V5.25014H1.50002V3.75014ZM3.00002 6.75014H1.50002V8.25014H3.00002V6.75014ZM1.50002 9.75014H3.00002V11.2501H1.50002V9.75014ZM3.00002 12.7501H1.50002V14.2501H3.00002V12.7501ZM15 3.75H16.5V5.25H15V3.75ZM16.5 6.75H15V8.25H16.5V6.75ZM15 9.75H16.5V11.25H15V9.75ZM16.5 12.75H15V14.25H16.5V12.75Z"
          fill="white"
        />
      </svg>
    </button>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from '@vue/composition-api'
import RadioListPlayButtonParts from '@/components/RaceVideoPage/common/parts/RadioListPlayButtonParts.vue'
import RadioDataDocument from '@/store/stores/collectionModule/documents/Radio/RadioDataDocument'

/**
 * レース動画再生画面 選手選手用 無線アイテムのコンポーネント
 */
export default defineComponent({
  name: 'RadioListItemParts',
  components: {
    RadioListPlayButtonParts,
  },
  props: {
    /**
     * 画面向き
     */
    screenOrientationType: {
      type: String,
      default: 'portrait-primary',
    },
    /**
     * 選手無線データ
     */
    radioData: {
      type: Object as PropType<RadioDataDocument>,
      require: true,
    },
  },
  setup(props, context) {
    const playerRadioData = computed(() => props.radioData)
    const lap = computed(() => props.radioData?.lap)
    const sector = computed(() => props.radioData?.sector)

    /**
     * 無線再生が実施された際に呼び出される。
     *
     * @param scene 動画再生位置の変更を行うかどうか。
     */
    const playSelectPlayerRadio = (scene: boolean): void => {
      context.emit('selectPlayerRadioPlay', props.radioData, scene)
    }

    return {
      playSelectPlayerRadio,
      playerRadioData,
      lap,
      sector,
    }
  },
})
</script>

<style lang="scss" scoped>
.radio-list-item-parts {
  --race-select-height: calc(var(--screen-height) - 56.25vw - 44px);

  font-size: min(3.2vw, calc(var(--screen-height) * 0.0217));
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 9px 12px 8px 0;
  border-bottom: 1px solid rgba(#fff, 10%);

  &__video-scene-select {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    width: calc(100% - 102px);
    height: 36px;
    @include fontSetTextSmall();

    color: $gray25;

    &__information {
      width: calc(100% - 30px);
    }

    &__icon {
      width: 18px;
    }
  }

  &--landscape-primary,
  &--landscape-secondary {
    --race-select-height: calc(var(--screen-height) - 44px);

    .radio-list-item-parts {
      &__video-scene-select {
        width: calc(100% - 72px);
      }
    }
  }
}
</style>
